import { styled } from '@linaria/react';

import { ButtonBase, DiscountLabel } from '~shared/ui/atoms';

export const StyledLabel = styled(DiscountLabel)`
	position: absolute;
	top: 0;
	right: 0;
	transform: translate(-30px, -15px);
`;

export const StyledBase = styled(ButtonBase)`
	box-shadow: var(--shadow-white);

	& ${StyledLabel} {
		box-shadow: var(--shadow-white);
	}

	@media (pointer: fine) {
		&:hover {
			box-shadow: var(--shadow-white-active);

			& ${StyledLabel} {
				/* Seems lokks good w/out extra shadow */
			}
		}
	}

	@media (pointer: coarse) {
		&:active {
			box-shadow: var(--shadow-white-active);

			& ${StyledLabel} {
				/*  */
			}
		}
	}

	&[disabled] {
		--bg: var(--color-white-01);
		--color: var(--color-white-03);
		backdrop-filter: blur(15px);
		box-shadow: none;

		& ${StyledLabel} {
			box-shadow: none;
		}
	}
`;
